const MULBERRY = '#7A0534';
const BADGE_HEIGHT = 20;
const CAP_WIDTH = 3;
const LEFT_CAP_PATH = 'M2.25 0H0L2.25 2L0 4L2.25 6L0 8L2.25 10L0 12L2.25 14L0 16L2.25 18L0 20H2.25V0Z';
const RIGHT_CAP_PATH = 'M0 0H2.25L0 2L2.25 4L0 6L2.25 8L0 10L2.25 12L0 14L2.25 16L0 18L2.25 20H0V0Z';
interface Props {
  label: string;
}
const FlashSalePriceBadge = ({
  label
}: Props) => <span className="inline-flex items-center shrink-0" style={{
  height: BADGE_HEIGHT
}} data-sentry-component="FlashSalePriceBadge" data-sentry-source-file="FlashSalePriceBadge.tsx">
    <svg width={CAP_WIDTH} height={BADGE_HEIGHT} viewBox="0 0 2.25 20" className="block shrink-0" aria-hidden data-sentry-element="svg" data-sentry-source-file="FlashSalePriceBadge.tsx">
      <path d={LEFT_CAP_PATH} fill={MULBERRY} data-sentry-element="path" data-sentry-source-file="FlashSalePriceBadge.tsx" />
    </svg>
    <span className="inline-flex items-center justify-center text-white text-sm font-semibold leading-none px-0.5 -mx-px whitespace-nowrap" style={{
    backgroundColor: MULBERRY,
    height: BADGE_HEIGHT
  }}>
      {label}
    </span>
    <svg width={CAP_WIDTH} height={BADGE_HEIGHT} viewBox="0 0 2.25 20" className="block shrink-0" aria-hidden data-sentry-element="svg" data-sentry-source-file="FlashSalePriceBadge.tsx">
      <path d={RIGHT_CAP_PATH} fill={MULBERRY} data-sentry-element="path" data-sentry-source-file="FlashSalePriceBadge.tsx" />
    </svg>
  </span>;
export default FlashSalePriceBadge;